import { Button, Card, Title2 } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <Card>
        <Title2>Unauthorized</Title2>
        <p>You do not have enough permissions to access this page.</p>
        <Button onClick={() => navigate('/dashboard')}>Back to dashboard</Button>
      </Card>
    </div>
  );
};
